import { Outlet } from 'react-router-dom'
;
import Seventhgrade_k7_subjects from './seventhgrade_k7_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Seventhgrade_k7 = ( ) => {
 
  return (
    <>
   
   
   <TopNavbar />
  <Seventhgrade_k7_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Seventhgrade_k7;